export const TRANSACTION_TYPE_POTRAVINY = 'potraviny';
export const TRANSACTION_TYPE_NAFTA = 'nafta';
export const transactionTypes = [TRANSACTION_TYPE_POTRAVINY, TRANSACTION_TYPE_NAFTA];

export const transactionApiUrl = process.env.REACT_APP_API_URL;

export const ID_TOKEN_STORAGE_KEY = 'id_token';
export const EXPIRED_TOKEN_MESSAGE = 'The incoming token has expired';
